import { useTranslation } from '@utils';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import FeedbackScreenTitle from '../common/feedback-screen-title';
import FeedbackSubmitButton from '../common/feedback-submit-button';
import { useLowScoreAnswers } from '../hooks/use-low-score-answers';
import CommentField from './comment-field';
import FollowUpQuestions from './follow-up-questions';
import ReasonChips from './reason-chips';

const FeedbackLowScoreScreen = ({
  lowScore, buttonText, isSubmitting, onSubmit,
}) => {
  const getTranslation = useTranslation();
  const {
    values, isValid, toggleReason, setAnswer, setComment,
  } = useLowScoreAnswers(lowScore);

  const handleSubmit = useCallback(() => onSubmit(values), [onSubmit, values]);

  return (
    <div className="px-5 py-6 flex flex-col gap-4">
      <FeedbackScreenTitle title={lowScore.headerPrompt} />
      {lowScore.reasonsEnabled && lowScore.reasons.length > 0 && (
        <ReasonChips
          reasons={lowScore.reasons}
          selected={values.reasons}
          mandatory={lowScore.reasonsMandatory}
          onToggle={toggleReason}
        />
      )}
      {lowScore.questionsEnabled && (
        <FollowUpQuestions questions={lowScore.questions} answers={values.answers} onAnswerChange={setAnswer} />
      )}
      <CommentField
        label={lowScore.commentPlaceholder}
        mandatory={lowScore.commentMandatory}
        value={values.comment}
        onChange={setComment}
      />
      <FeedbackSubmitButton
        label={buttonText || getTranslation('FEEDBACK_SUBMIT_LABEL')}
        disabled={!isValid}
        loading={isSubmitting}
        onClick={handleSubmit}
      />
    </div>
  );
};

FeedbackLowScoreScreen.propTypes = {
  lowScore: PropTypes.shape({
    headerPrompt: PropTypes.string,
    reasonsEnabled: PropTypes.bool,
    reasonsMandatory: PropTypes.bool,
    reasons: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      slot: PropTypes.number,
    })),
    questionsEnabled: PropTypes.bool,
    questions: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      mandatory: PropTypes.bool,
      slot: PropTypes.number,
    })),
    commentPlaceholder: PropTypes.string,
    commentMandatory: PropTypes.bool,
  }).isRequired,
  buttonText: PropTypes.string,
  isSubmitting: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

FeedbackLowScoreScreen.defaultProps = {
  buttonText: '',
  isSubmitting: false,
};

export default FeedbackLowScoreScreen;
